import { Box, Grid } from "@mui/material";
import React from "react";
import {
  AutocompleteElement,
  FieldValues,
  FormContainer,
  TextFieldElement,
  useForm,
} from "react-hook-form-mui";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/shared/context/useAuth";
import { TCaseFilter } from "../data-access/types";
import CustomDatePicker from "src/shared/components/CustomDatePicker";
import { LoadingButton } from "@mui/lab";

export default function CaseFilters({
  filters,
  onSuccess,
}: {
  filters: TCaseFilter[];
  onSuccess: (data: FieldValues) => void;
}) {
  const { t } = useTranslation();

  const formContext = useForm();

  return (
    <Box>
      <FormContainer formContext={formContext} onSuccess={onSuccess}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Grid container spacing={2}>
            {filters.map((filter) => (
              <Grid item xs={12} sm={6} md={4} key={filter.name}>
                {filter.component.type === "textField" && (
                  <TextFieldElement
                    fullWidth
                    name={filter.name}
                    label={filter.label}
                  />
                )}
                {filter.component.type === "autoComplete" && (
                  <AutocompleteElement
                    name={filter.name}
                    label={filter.label}
                    options={filter.component.options}
                    autocompleteProps={{
                      fullWidth: true,
                      isOptionEqualToValue: (option, value) =>
                        option.value == value.value,
                    }}
                    loading={filter.component.loading}
                  />
                )}
                {filter.component.type === "datePicker" && (
                  <CustomDatePicker
                    sx={{ width: "100%" }}
                    name={filter.name}
                    label={filter.label}
                    format={"dd/MM/yyyy"}
                  />
                )}
              </Grid>
            ))}
          </Grid>
          <LoadingButton
            sx={{ alignSelf: "start" }}
            variant="contained"
            type="submit"
          >
            {t("Αναζήτηση")}
          </LoadingButton>
        </Box>
      </FormContainer>
    </Box>
  );
}
